import React, { useState, useEffect } from "react";
import { Grid, Paper, Typography, Box, Card, CardContent } from "@mui/material";
import {
  Message as MessageIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";
import api from "../config/axios";

function Dashboard() {
  const [stats, setStats] = useState({
    totalMessages: 0,
    autoMessages: 0,
    activeInvites: 0,
    totalInvites: 0,
  });
  const [settings, setSettings] = useState({
    auto_message_interval: "50",
    twitch_channel: "laboite_fred",
  });

  useEffect(() => {
    fetchStats();
    fetchSettings();
  }, []);

  const fetchStats = async () => {
    try {
      // Récupérer les messages
      const messagesResponse = await api.get("/api/messages");
      const messages = messagesResponse.data;
      const autoMessages = messages.filter((msg) => msg.is_auto === 1);

      // Récupérer les invités
      const invitesResponse = await api.get("/api/invites");
      const invites = invitesResponse.data;
      const activeInvites = invites.filter((inv) => inv.is_active === 1 || inv.is_active === true);

      setStats({
        totalMessages: messages.length,
        autoMessages: autoMessages.length,
        activeInvites: activeInvites.length,
        totalInvites: invites.length,
      });
    } catch (error) {
      console.error("Erreur lors de la récupération des stats:", error);
    }
  };

  const fetchSettings = async () => {
    try {
      const response = await api.get("/api/settings");
      setSettings(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des paramètres:", error);
    }
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Tableau de bord
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <MessageIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6">Messages</Typography>
              </Box>
              <Typography variant="h4">{stats.totalMessages}</Typography>
              <Typography color="textSecondary">
                {stats.autoMessages} automatiques
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <PeopleIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6">Invités</Typography>
              </Box>
              <Typography variant="h4">{stats.activeInvites}</Typography>
              <Typography color="textSecondary">
                actif{stats.activeInvites > 1 ? "s" : ""} sur {stats.totalInvites}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: "100%" }}>
            <CardContent sx={{ height: "100%" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <SettingsIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6">Configuration</Typography>
              </Box>
              <Typography variant="body1">
                Intervalle des messages : {settings.auto_message_interval}
              </Typography>
              <Typography variant="body1">Canal : {settings.twitch_channel}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Statistiques
            </Typography>
            <Typography variant="body2" color="textSecondary">
              • {stats.totalMessages} messages configurés ({stats.autoMessages} automatiques)
            </Typography>
            <Typography variant="body2" color="textSecondary">
              • {stats.activeInvites} invité{stats.activeInvites > 1 ? "s" : ""} actif{stats.activeInvites > 1 ? "s" : ""} sur {stats.totalInvites} total
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Dashboard;
